import { PropsWithChildren } from 'react';
import { Root as DefaultRoot } from '@platt-internal/backstage-plugin-bootstrap-react';

export const Root = ({ children }: PropsWithChildren<{}>) => 
  (
    <DefaultRoot>
      {children}
    </DefaultRoot>
  );
